<template>
  <div class="excel-import-error-content">
    <p
      v-for="(line, index) in lines"
      :key="index"
      class="error-line"
    >
      {{ line }}
    </p>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

type TProps = {
  errorMessage: string;
};

const props = defineProps<TProps>();

// 複数行のエラーを "\n" 区切りで返すため、行ごとに分割して左寄せで表示する。
// TODO: リードステージ・カスタム項目インポートをエラーメッセージを集約するように変更する際にBEから返す値も調整する。
const lines = computed(() => props.errorMessage.split('\n'));
</script>

<style lang="scss" scoped>
.excel-import-error-content {
  text-align: left;
  .error-line {
    margin: 0 0 $basespace-100;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
